import React, {lazy} from "react";
import {Routes, Route} from "react-router-dom";
import { CLUB_FIELDS_PATH, CLUB_FORMS_PATH, CLUB_TEAMS_PATH } from "../../routes";

const Teams = lazy(() => import("../Teams/Teams"));
const Fields = lazy(() => import("../Fields/Fields"));
const Forms = lazy(() => import("../Forms/Forms"));

export const Club = () => {
    return (
        <main className="grow p-6">
            <Routes>
                <Route path={CLUB_TEAMS_PATH} element={<Teams/>}/>
                <Route path={CLUB_FIELDS_PATH} element={<Fields/>}/>
                <Route path={CLUB_FORMS_PATH} element={<Forms/>}/>
            </Routes>
        </main>
    );
};

export default Club;
